import FournitureView from "@features/achats/components/fournitures/FournitureView";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Link2 } from "lucide-react";

export const Route = createFileRoute("/_app/achats/fournitures/$id/view")({
  staticData: {
    title: "Détails Fourniture",
    icon: Link2,
    permission: PERMISSIONS.ACHATS.FOURNITURES.VIEW,
    module: "achats",
    showInTab: false,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: FournitureView,
});
